import React from 'react';
import { CheckCircle, Bug, TestTube, Target } from 'lucide-react';

export default function QADashboard() {
  const cardClasses = 'bg-white/10 backdrop-blur-md border border-white/20';

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-pink-900 text-white p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            Dashboard QA
          </h1>
          <p className="text-lg opacity-80 mt-2">Control de Calidad y Testing</p>
        </div>

        <div className={`${cardClasses} p-8 rounded-2xl text-center`}>
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mb-6">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl font-bold mb-4">Área en Construcción</h2>
          <p className="text-gray-300 mb-6">
            El dashboard de QA estará disponible próximamente con métricas de:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            <div className={`${cardClasses} p-4 rounded-lg`}>
              <Bug className="w-8 h-8 mx-auto mb-2 text-purple-400" />
              <p className="font-semibold">Bugs Detectados</p>
            </div>
            <div className={`${cardClasses} p-4 rounded-lg`}>
              <TestTube className="w-8 h-8 mx-auto mb-2 text-pink-400" />
              <p className="font-semibold">Tests Ejecutados</p>
            </div>
            <div className={`${cardClasses} p-4 rounded-lg`}>
              <Target className="w-8 h-8 mx-auto mb-2 text-purple-300" />
              <p className="font-semibold">Cobertura</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
